import { Icon } from '@iconify/react';
import { useCallback, useEffect, useState } from 'react';
// material
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
// other icons
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useDispatch } from 'react-redux';
import { MdNotificationsNone } from 'react-icons/md';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import {
  getCityData,
  getLoanTypeData,
  getSourceListData,
  getStatusList
} from '../../store/Slice/Global/GlobalSlice';
import useReceiveSelector from '../../store/Slice/Receive/ReceiveSelector';
// import useRejectedSelector from 'src/store/Slice/Rejected/RejectedSelector';
import useRejectedSelector from '../../store/Slice/Rejected/RejectedSelector';

export default function RejectedToolbar({
  filterName,
  onFilterName,
  filterDatesRange,
  setFilterDatesRange,
  filterState,
  setFilterState,
  setFilterName
}) {
  const [isOpenFilter, openFilter] = useState(false);
  const [uniqueReasonOptions, setUniqueReasonOptions] = useState([]);
  const { ReceiveListData } = useReceiveSelector();

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { CityDrop, LoanTypeDrop, StatusDrop, SourceDrop, BankDrop } = useGlobalSelector();
  const { RejectedListData } = useRejectedSelector();

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setFilterState((prev) => ({
      ...prev,
      bankId: null,
      loanTypeId: null,
      product: ' ',
      productId: null,
      city: null,
      cityId: null,
      status: ' ',
      statusId: null,
      rejectedReasonTypeId: null,
      reason: null
    }));
    setFilterName('');
  };

  const getLoanMasterApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData]);

  //  city api
  const handleGetState = useCallback(
    (optionVal) => {
      const data = {
        ...(optionVal && { stateId: optionVal }),
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        searchLiteral: '',
        sortOrder: 'desc'
      };
      dispatch(getCityData(data)); // fetch city data
    },
    [LoginData?.companyId, LoginData?.userId] // dependencies
  );

  useEffect(() => {
    handleGetState(null); // city list
    getLoanMasterApi(); // loan master list
    dispatch(getStatusList(58)); // status list
    dispatch(getSourceListData()); // source list
  }, []);

  useEffect(() => {
    if (!RejectedListData?.length || uniqueReasonOptions.length > 0) return;

    const uniqueData = RejectedListData.filter(
      (r, idx, self) => self.findIndex((x) => x?.reason === r?.reason) === idx
    ).map((r) => ({
      label: r?.reason,
      value: r?.reasonId
    }));

    setUniqueReasonOptions(uniqueData);
  }, [RejectedListData]); // 🔥 runs only when data is first loaded

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.bankId ?? ' '}
                onChange={(e) => {
                  setFilterState((prev) => ({ ...prev, bankId: e.target.value }));
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.bankId}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Bank
                </MenuItem>
                {BankDrop?.map((productItem) => (
                  <MenuItem key={productItem?.value} value={productItem?.value}>
                    {productItem.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.loanTypeId ?? ' '}
                onChange={(e) => {
                  setFilterState((prev) => ({ ...prev, loanTypeId: e.target.value }));
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.loanTypeId}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Product Type
                </MenuItem>
                {LoanTypeDrop?.map((productItem) => (
                  <MenuItem key={productItem?.value} value={productItem?.value}>
                    {productItem.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {/* <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid> */}
            <Grid item xs>
              <Autocomplete
                disablePortal
                id="combo-box-demo8"
                size="small"
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
                value={filterState.city ?? null}
                options={CityDrop || []}
                getOptionLabel={(option) => option?.label ?? ''}
                renderOption={(props, option) => <li {...props}>{option?.label ?? ''}</li>}
                onChange={(e, newValue) => {
                  setFilterState((prev) => ({
                    ...prev,
                    city: newValue ?? null,
                    cityId: newValue ? newValue.value : null
                  }));
                }}
              />
            </Grid>
            {/* {console.log('sss RejectedListData', RejectedListData)} */}

            <Grid item xs>
              <Select
                fullWidth
                value={filterState.rejectedReasonTypeId ?? ' '}
                onChange={(e) => {
                  setFilterState((prev) => ({ ...prev, rejectedReasonTypeId: e.target.value }));
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.rejectedReasonTypeId}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Rejection Reason
                </MenuItem>
                {uniqueReasonOptions.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {/* <Grid item xs>
              <Select
                fullWidth
                value={filterState.employmentType}
                onChange={(e) => {
                  const prevData = filterState;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.employmentType = e.target.value;
                  prevData.employmentTypeId = inputVal.typeId;
                  setFilterState({ ...filterState, prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.employmentType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Source
                </MenuItem>
                {SourceDrop?.map((productItem, productIndex) => (
                  <MenuItem key={productItem?.value} value={productItem?.value}>
                    {productItem.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid> */}
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton
                  sx={{ padding: '0', paddingTop: '0.4rem', paddingBottom: '0.4rem' }}
                  onClick={(e) => {
                    handleRemoveFilter(e);
                  }}
                >
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          {/* <Tooltip title="Notification" placement="top" arrow className="disabledDocument">
            <IconButton className="squareIconButton">
              <MdNotificationsNone size={18} />
            </IconButton>
          </Tooltip> */}
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Rejection"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list" className="">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
